import { boolean, OutSearchParams, route, string, union } from 'react-router-typesafe-routes';

import { FindScheduleOrder } from 'chaika-frontend-types/frontend-cms';

import { civilDate, formatCivilDate } from '@utils/civilDate';

export { CIVIL_DATE_FORMAT } from '@utils/civilDate';

const TODAY = formatCivilDate(new Date());

export const SCHEDULE_V2_ROUTE = route({
    path: 'schedule',
    searchParams: {
        from: string(civilDate).default(TODAY),
        to: string(civilDate).default(TODAY),
        organizationId: string(),
        userId: string().array(),
        officeId: string().array(),
        specialtyId: string().array(),
        serviceId: string().array(),
        patientId: string(),
        orderBy: union(FindScheduleOrder).default(FindScheduleOrder.USER),
        cancelledReservations: boolean().default(false),
        notWorking: boolean().default(false),
        confidential: boolean().default(false),
    },
});

export type ScheduleV2UrlState = OutSearchParams<typeof SCHEDULE_V2_ROUTE.$spec>;

export function hasScheduleV2UrlState(rawSearchParams: URLSearchParams): boolean {
    return Object.keys(SCHEDULE_V2_ROUTE.$spec.searchParams).some(key => rawSearchParams.has(key));
}
